import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from '../../services/API/api.service';

@Component({
  selector: 'app-counter-cancelled-consumption',
  templateUrl: './counter-cancelled-consumption.component.html',
  styleUrl: './counter-cancelled-consumption.component.css'
})
export class CounterCancelledConsumptionComponent implements OnInit{
  @Input() createdAtItem: any = new Date();
  @Input() id_item: any;
  // @Input() id_company!: string;
  @Input() fontSize: any = '';
  @Output() finalizionCounter: EventEmitter<boolean> = new EventEmitter<boolean>();
  counterMin: number = 0;
  counterSec: number = 0;
  intervalId: any;
  dashoffset: number = 10;
  dateServer: string = '';
  start: boolean = false;

  constructor(private apiService: ApiService){}

  ngOnInit(): void {
    this.createdAtItem = new Date(this.createdAtItem);
    this.getDateServer();
  }

  startCounter():void {
    const dashArray = 380;

    const targetTime = new Date(this.dateServer);

    // difereça de 8 min desde que o pedido foi criado
    const differential = 3 * 60 * 1000;

    //Total em milesegundos
    const totalMilisegundos = differential

    //Adiciona essa diferença a hora do pedido
    const newDate = new Date(targetTime.getTime() + differential);
    
    // Resgata a hora atual
    const currentTime = new Date(this.dateServer);
    
    // Calcular a diferença
    let diferencaEmMilissegundos = newDate.getTime() - currentTime.getTime();

    // Extrair minutos e segundos da diferença
    const diferencaEmMinutos = Math.floor((diferencaEmMilissegundos % (60 * 60 * 1000)) / (60 * 1000));
    const diferencaEmSegundos = Math.floor((diferencaEmMilissegundos % (60 * 1000)) / 1000);

    if(diferencaEmMinutos >= 0 && diferencaEmSegundos >= 0)
    {
      this.counterMin =  diferencaEmMinutos;
      this.counterSec = diferencaEmSegundos;
    }
    else{
      this.counterMin = 0;
      this.counterSec = 0;
      this.finalizionCounter.emit(true);
    }

    this.start = true;

    this.intervalId = setInterval(() =>{
      if(this.counterMin >= 0)
      {
        if(this.counterSec != 0)
        {
          this.counterSec --
        }
        else if(this.counterSec === 0)
        {
          if(this.counterMin === 0)
          {
            clearInterval(this.intervalId);
            this.finalizionCounter.emit(true);
            this.cancelItem();
          }
          else{
            this.counterMin --;
            this.counterSec = 59
          }

        }
      }

      diferencaEmMilissegundos = diferencaEmMilissegundos - 1000
      let remainingSeconds = diferencaEmMilissegundos;
    
      const updateCircleProgress = () => {
        const percentage = remainingSeconds / totalMilisegundos;
        const dashoffset = dashArray * (1 - percentage);
        this.dashoffset = dashoffset
      };

      updateCircleProgress();
    }, 1000);

  }

  getDateServer(){
    this.apiService.getHours().subscribe(
      (data) =>{
        this.dateServer = data.date;
        this.startCounter();
      },
      (error) =>{
        console.log(error);
      }
    )
  }

  cancelItem(){
    // this.apiService.cancelItem(this.id_item).subscribe(
    // (data) =>{
    //   console.log(data);
    // },
    // (error) =>{
    //   console.log(error);
    // });
  }
}
